import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=461d57f4&"
import script from "./collapse.vue?vue&type=script&lang=js&"
export * from "./collapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('461d57f4')) {
      api.createRecord('461d57f4', component.options)
    } else {
      api.reload('461d57f4', component.options)
    }
    module.hot.accept("./collapse.vue?vue&type=template&id=461d57f4&", function () {
      api.rerender('461d57f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/collapse/src/collapse.vue"
export default component.exports